import styled from 'styled-components'

import { media } from '../../../../../../utils/style-utils'

export const MobileButtonsWrapper = styled.div`
  display: none;
  ${media.touch`
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: block;
  `}
`
